import axios from 'axios'

const video = {}
// 所有视频
video.list = params => { return axios.get('/video/find', {params}) }
// 加载单个
video.load = params => { return axios.get('/video/load', {params}) }
// 上传视频
video.upload = params => { return axios.post('/video/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } }) }
// 上传图片
video.uploadPhoto = params => { return axios.post('/video/uploadLecturerPhoto', params, { headers: { 'Content-Type': 'multipart/form-data' } }) }

//录播视频禁播
video.saveVideoPath = params => { return axios.post('/videoPath/update', params) }

export default video



// WEBPACK FOOTER //
// ./src/api/video.js